export default __webpack_public_path__ + "static/media/23.b8dc6698.mp3";